module.exports = __webpack_public_path__ + "img/bcbc.85d846ff.svg";